import { createSelector } from 'reselect';

export const getSelectedFeatureId = createSelector(
  state => state,
  state => state.feature?.selectedData?.id ?? null,
);

export const getMouseOverFeatureId = createSelector(
  state => state,
  state => state.feature?.mouseoverData?.id ?? null,
);
